import { Menu } from "lucide-react";
import type { User } from "firebase/auth";

type TopBarProps = {
  user: User;
  onMenuOpen: () => void;
};

export function TopBar({ user, onMenuOpen }: TopBarProps) {
  return (
    <header className="flex h-14 items-center border-b bg-card px-4 md:px-6">
      <button
        className="lg:hidden -ml-1 mr-2 rounded-md p-1.5 text-muted-foreground hover:bg-muted"
        onClick={onMenuOpen}
        aria-label="Open menu"
      >
        <Menu className="size-5" />
      </button>
      <span className="ml-auto text-sm text-muted-foreground">{user.email}</span>
    </header>
  );
}
